import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";
import SectionHeading from "@/components/common/SectionHeading";
import { CAPABILITIES } from "@/lib/data";

export default function AIHiringEngine() {
  return (
    <section className="relative py-24 sm:py-32 overflow-hidden" data-testid="ai-hiring-engine">
      <div className="absolute inset-0 -z-10">
        <img
          src="https://images.unsplash.com/photo-1579567761406-4684ee0c75b6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHxhYnN0cmFjdCUyMGhpZ2glMjB0ZWNoJTIwbmV0d29yayUyMG5vZGVzJTIwZGFyayUyMGJsdWV8ZW58MHx8fHwxNzgzODExNDYyfDA&ixlib=rb-4.1.0&q=85"
          alt=""
          className="w-full h-full object-cover opacity-15"
          loading="lazy"
        />
        <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, #0A1023 0%, rgba(10,16,35,0.6) 40%, #0A1023 100%)" }} />
      </div>

      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <SectionHeading
          eyebrow="Why Choose SKVY Harmony"
          title="Everything you need to land your US tech role — under one roof."
          sub="AI-powered matching, senior US recruiters, visa-friendly employers and end-to-end career support. Built for international students, OPT, CPT and H-1B professionals."
        />

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-6 mt-16">
          {CAPABILITIES.map((c, i) => (
            <motion.div
              key={c.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              className="glass rounded-2xl p-6 glow-hover"
              data-testid={`capability-${i}`}
            >
              <div className="w-11 h-11 rounded-xl flex items-center justify-center mb-5"
                style={{ background: "linear-gradient(135deg, rgba(30,58,138,0.5), rgba(16,185,129,0.5))" }}>
                <c.icon className="w-5 h-5 text-white" strokeWidth={2} />
              </div>
              <p className="font-poppins text-white text-lg font-medium mb-2">{c.title}</p>
              <p className="font-inter text-sm text-white/55 leading-relaxed">{c.desc}</p>
            </motion.div>
          ))}
        </div>

        <div className="mt-16 flex items-center justify-center gap-3">
          <Sparkles className="w-4 h-4 text-[#10B981]" />
          <p className="font-inter text-sm text-white/50">Every AI shortlist is validated by a senior US recruiter before you're submitted.</p>
        </div>
      </div>
    </section>
  );
}
